import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { userActions } from '../actions';
import { generalActions } from '../actions';

class ResetPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newPassword: '',
      confirmPassword: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {}

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    const {match} = this.props;
    const {params} = match;
    const {selector, token} = params;

    this.setState({ submitted: true });

    const { confirmPassword } = this.state;
    const { dispatch } = this.props;
    if (confirmPassword) {
      dispatch(userActions.reset(confirmPassword, selector, token));
    }
  }

  render() {
    const { loggingIn } = this.props;
    const { newPassword, confirmPassword, submitted } = this.state;

    return (
      <div className="container">
        <div className="content">
          <Link to={`${process.env.PUBLIC_URL}/login`} className="link-back">
            <i className="fa fa-arrow-left" />
          </Link>{' '}
          <h1>Reset Password</h1>
          <form name="form" onSubmit={this.handleSubmit}>
            <div className={'form-group' + (submitted && !newPassword ? ' has-error' : '')}>
              <label htmlFor="username">New Password</label>
              <input
                type="password"
                className="form-control"
                name="newPassword"
                value={newPassword}
                onChange={this.handleChange}
                placeholder="new password"
              />
              {submitted && !newPassword && <div className="help-block">Password is required</div>}
            </div>
            <div className={'form-group' + (submitted && !confirmPassword ? ' has-error' : '')}>
              <label htmlFor="username">Confirm Password</label>
              <input
                type="password"
                className="form-control"
                name="confirmPassword"
                value={confirmPassword}
                onChange={this.handleChange}
                placeholder="confirm password"
              />
              {submitted &&
                !confirmPassword && <div className="help-block">Confirm is required</div>}
            </div>
            <div>
              {submitted && newPassword !== confirmPassword ? (
                <div className="form-group has-error">
                  <div className="help-block">New Password & Confirm Password are not the same</div>
                </div>
              ) : (
                <div />
              )}
            </div>
            <button className="btn btn-success">Reset Password</button>
            {loggingIn && (
              <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            )}
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn
  };
}

const connectedResetPage = connect(mapStateToProps)(ResetPage);
export { connectedResetPage as ResetPage };



// WEBPACK FOOTER //
// ./src/pages/ResetPage.js